export default __webpack_public_path__ + "static/media/HelveticaNeueCyr-UltraLight.92aee0fa.woff2";